import championFont from "../assets/fonts/ChampionHTF-LightweightRegular/Champion-HTF-Lightweight-Regular.otf";
import bornReadyFont from "../assets/fonts/BornReadyW05Regular/WebFonts/ae9402c994ca14b82833d8d67529c560.ttf";
import clarendonFont from "../assets/fonts/ClarendonLTStdLight/ClarendonLStdLight.otf";

const fonts: { href: string; type: string }[] = [
  { href: championFont, type: "font/otf" },
  { href: bornReadyFont, type: "font/ttf" },
  { href: clarendonFont, type: "font/otf" },
];

export function preloadFonts() {
  fonts.forEach(({ href, type }) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "font";
    link.type = type;
    link.href = href;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  });
}
